import jsCookie from 'js-cookie'

type CookieOptions = {
  domain: string;
  expires: number;
  path: string;
  sameSite: 'strict' | 'lax' | 'none';
  secure: boolean;
}

export default class CookieService {
  public static setCookie(key: string, value: string, attributes?: Partial<CookieOptions>) {
    jsCookie.set(key, value, attributes)
  }

  public static getCookie(key: string) {
    return jsCookie.get(key)
  }

  public static removeCookie(key: string) {
    jsCookie.remove(key)
  }
}
